import "./OutletCancelModal.css";
import Modal from "@mui/material/Modal";
import NegativeIconImgSrc from "../../../assets/image/png/error.png";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { customSx } from "../../../components/createSecondaryOrder/util";
import { customStyle } from "../../viewOrder/ViewOrderUtils";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react"; // 1. Import useEffect

interface OutletCancelModalProps {
  headerText: string;
  modalOpen: boolean;
  selectedRejectionReason: string;
  loading: boolean;
  onClose: () => void;
  onButtonClick: () => void;
  inputActive?: boolean;
  inputString?: string;
  rejectionReasons: string[];
  handleReasonStringChange?: (param: string) => void;
  handleReasonChange?: (param: string) => void;
}

const OutletCancelModal: React.FC<OutletCancelModalProps> = ({
  headerText = "",
  modalOpen = false,
  selectedRejectionReason = "",
  loading = false,
  onClose = () => {},
  onButtonClick = () => {},
  inputActive,
  inputString = "",
  rejectionReasons = [],
  handleReasonStringChange = () => {},
  handleReasonChange = () => {},
}) => {
  const isButtonDisabled =
    selectedRejectionReason?.length === 0 ||
    loading;

  // 2. Add useEffect to handle the 'Escape' key press
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    // Add event listener only when the modal is open
    if (modalOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup: remove event listener when the component unmounts or modal closes
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [modalOpen, onClose]); // Dependencies for the effect

  return (
    <Modal
      open={modalOpen}
      onClose={onClose} // 3. It's good practice to also pass onClose to the Modal component itself
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="cancel-Outlet-modal-container">
        <button
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            background: "none",
            border: "none",
          }}
          onClick={onClose}
        >
          <CloseIcon
            style={{
              color: "#707070",
            }}
          />
        </button>
        <div className="outlet_cancel_model_rows">
          <img src={NegativeIconImgSrc} className="OutletCancelModal_img" />
          <p className="OutletCancelModal_header">{headerText}</p>
          <p className="">Please mention the reason:</p>

          <FormControl
            fullWidth
            size="small"
            className="custom_form_control"
            sx={{ ...customSx, width: "100%" }}
          >
            <InputLabel sx={customSx} id="order-type-label">
              Select Reason
            </InputLabel>
            <Select
              id="selectedRejectionReason"
              value={selectedRejectionReason}
              onChange={(e) => {
                handleReasonChange(e.target.value);
                // handleReasonStringChange("");
              }}
              className="select_customer_textfield"
              size="small"
              fullWidth
              sx={customSx}
              label="Select Reason"
            >
              {rejectionReasons?.map((rejectionReason) => (
                <MenuItem
                  key={rejectionReason}
                  value={rejectionReason}
                  sx={{
                    color: "#464646",
                    fontSize: "14px",
                  }}
                >
                  {rejectionReason}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <button
            className="OutletCancelModal_button"
            disabled={isButtonDisabled}
            style={{
              background: isButtonDisabled ? "#EBEBEB" : "#00C6B1",
              color: isButtonDisabled ? "#7C7C7C" : "#FFFFFF",
              cursor: isButtonDisabled ? "not-allowed" : "pointer",
            }}
            onClick={onButtonClick}
          >
            {loading ? <CircularProgress style={customStyle} /> : "Continue"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OutletCancelModal;
